/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxFiles: NonNullable<unknown> }} Case_Dropzone_Accept_With_LimitInputs */

const en_case_dropzone_accept_with_limit = /** @type {(inputs: Case_Dropzone_Accept_With_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Documents, images, and videos · up to ${i?.maxFiles} files per upload · files up to 50 MB, videos up to 250 MB`)
};

const pt_br2_case_dropzone_accept_with_limit = /** @type {(inputs: Case_Dropzone_Accept_With_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Documentos, imagens e vídeos · até ${i?.maxFiles} arquivos por envio · arquivos de até 50 MB, vídeos de até 250 MB`)
};

/**
* | output |
* | --- |
* | "Documents, images, and videos · up to {maxFiles} files per upload · files up to 50 MB, videos up to 250 MB" |
*
* @param {Case_Dropzone_Accept_With_LimitInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_dropzone_accept_with_limit = /** @type {((inputs: Case_Dropzone_Accept_With_LimitInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Dropzone_Accept_With_LimitInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_dropzone_accept_with_limit(inputs)
	return pt_br2_case_dropzone_accept_with_limit(inputs)
});